import React from 'react';
import styles from './TeamLogo.module.css';

interface EventLogoProps {
  eventKey: string;
  logoSize?: number;
  marginSize?: number;
}

const EventLogo: React.FC<EventLogoProps> = ({ eventKey, logoSize = 16, marginSize = 12 }) => {
  const logoUrl = `https://valolens-event-logos-891612567998.s3.amazonaws.com/${eventKey}.png`;

  return (
    <div className="d-inline-block">
      <img
        src={logoUrl}
        alt={`${eventKey} logo`}
        className={`img-fluid ${styles.logo}`}
        style={{ height: `${logoSize}px`, width: `${logoSize}px`, marginRight: `${marginSize}px` }}
        onError={(e) => {
          const target = e.target as HTMLImageElement;
          target.onerror = null;
          target.src = '/question-mark.png';
        }}
      />
    </div>
  );
};

export default EventLogo;
